module.exports = __webpack_public_path__ + "static/media/AAVE.53d2a898.svg";